import React, { useRef } from 'react';

interface ProductItem {
    id: number;
    title: string;
    image: string;
    rating: string;
    discount: string;
    originalPrice: string;
    price: string;
    bankOffer: string;
}

const similarData: ProductItem[] = [
    {
        id: 1,
        title: "Aroma NB126 Berry V5.4 U...",
        image: "https://rukminim2.flixcart.com/image/312/312/xif0q/headphone/e/a/f/-original-imagtc44nk4b3hfg.jpeg?q=70",
        rating: "3.8",
        discount: "85% OFF",
        originalPrice: "2,999",
        price: "439",
        bankOffer: "₹389 with Bank offer"
    },
    {
        id: 2,
        title: "Aroma NB126 Blaze 32dB A...",
        image: "https://rukminim2.flixcart.com/image/312/312/xif0q/headphone/p/r/z/nb119-titanium-48-hours-playtime-bluetooth-neckband-black-in-the-original-imagp6pccgxcdjzz.jpeg?q=70",
        rating: "3.8",
        discount: "85% OFF",
        originalPrice: "3,299",
        price: "499",
        bankOffer: "₹449 with Bank offer"
    },
    {
        id: 3,
        title: "Aroma NB126 Berry V5.4 U...",
        image: "https://rukminim2.flixcart.com/image/312/312/xif0q/headphone/0/x/j/-original-imagtc444z2pgyj8.jpeg?q=70",
        rating: "3.8",
        discount: "85% OFF",
        originalPrice: "2,999",
        price: "449",
        bankOffer: "₹399 with Bank offer"
    },
    {
        id: 4,
        title: "Qvee QV151 TWS In-Ear Wir...",
        image: "https://rukminim2.flixcart.com/image/312/312/xif0q/headphone/w/n/e/-original-imagszm6yfwbb24r.jpeg?q=70",
        rating: "3.6",
        discount: "79% OFF",
        originalPrice: "1,999",
        price: "426",
        bankOffer: "₹376 with Bank offer"
    },
    {
        id: 5,
        title: "TECHIO SwiftBeats Bluetoo...",
        image: "https://rukminim2.flixcart.com/image/312/312/xif0q/headphone/9/f/1/swiftbeats-bluetooth-wireless-earbuds-with-digital-screen-tws-original-imagqztgx6sbbkzs.jpeg?q=70",
        rating: "3.6",
        discount: "90% OFF",
        originalPrice: "4,999",
        price: "500",
        bankOffer: "₹450 with Bank offer"
    },
    {
        id: 6,
        title: "PTron Bassbuds Plus In-E...",
        image: "https://rukminim2.flixcart.com/image/312/312/kzzw5u80/headphone/3/r/y/bassbuds-plus-ptron-original-imagbvhytjhpffzw.jpeg?q=70",
        rating: "4.1",
        discount: "79% OFF",
        originalPrice: "2,899",
        price: "549",
        bankOffer: "₹499 with Bank offer"
    }
];

const ProductRow = ({ title, data }: { title: string, data: ProductItem[] }) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
        }
    };

    return (
        <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: '600', color: '#212121', marginBottom: '16px', marginTop: 0 }}>{title}</h2>

            <div style={{ position: 'relative' }}>
                <div
                    ref={scrollRef}
                    style={{
                        display: 'flex',
                        overflowX: 'auto',
                        gap: '16px',
                        paddingBottom: '8px',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }}
                    className="no-scrollbar"
                >
                    {data.map((item) => (
                        <div key={item.id} style={{ minWidth: '195px', maxWidth: '195px', cursor: 'pointer' }}>
                            <div
                                style={{
                                    width: '100%',
                                    height: '200px',
                                    backgroundColor: '#f1f2f4',
                                    position: 'relative',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '8px'
                                }}
                            >
                                <img src={item.image} alt={item.title} style={{ height: '90%', objectFit: 'contain' }} />

                                {/* Rating Pill */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        bottom: '8px',
                                        left: '8px',
                                        backgroundColor: 'white',
                                        padding: '2px 6px',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    <span style={{ fontSize: '12px', fontWeight: '600' }}>{item.rating}</span>
                                    <span style={{ color: '#388e3c', fontSize: '10px' }}>★</span>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '12px', alignItems: 'flex-start' }}>
                                <p style={{ color: '#212121', fontSize: '14px', fontWeight: '500', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', margin: 0 }}>
                                    {item.title}
                                </p>
                                <p style={{ color: '#388e3c', fontSize: '14px', fontWeight: '600', margin: 0 }}>{item.discount}</p>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <span style={{ color: '#878787', fontSize: '12px', textDecoration: 'line-through' }}>₹{item.originalPrice}</span>
                                    <span style={{ color: '#212121', fontSize: '16px', fontWeight: '600' }}>₹{item.price}</span>
                                </div>
                                <p style={{ color: 'var(--color-primary)', fontSize: '12px', fontWeight: '500', margin: 0 }}>{item.bankOffer}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Next Button */}
                <button
                    style={{
                        position: 'absolute',
                        right: '0',
                        top: '40%',
                        transform: 'translateY(-50%)',
                        zIndex: 2,
                        backgroundColor: 'white',
                        boxShadow: '0 2px 4px 0 rgba(0,0,0,.13)',
                        borderRadius: '50%',
                        height: '40px',
                        width: '40px',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'backgroundColor 0.2s'
                    }}
                    onClick={scrollRight}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
                >
                    <span style={{ fontSize: '24px', color: '#212121' }}>›</span>
                </button>
            </div>
            <style>
                {`
                .no-scrollbar::-webkit-scrollbar {
                    display: none;
                }
                `}
            </style>
        </div>
    );
};

export default function SimilarProducts() {
    return (
        <div style={{ borderTop: '1px solid #f0f0f0', marginTop: '32px', paddingTop: '32px' }}>
            <ProductRow title="Similar Bluetooth Headphones" data={similarData} />
            <ProductRow title="Discounts on Similar Products" data={similarData} />
        </div>
    );
}

